var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "SvgFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "SVG",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.4654958 14.226522q0 .235128-.08785.418579-.085266.183452-.2402956.312643-.1524456.126607-.3617352.191203-.2067059.0646-.4470014.0646-.1679485 0-.3126426-.02842-.1421103-.02842-.2557985-.06976-.1111044-.04134-.1886191-.08527-.074931-.04392-.1059368-.07493-.028422-.03101-.043925-.07752-.012919-.04909-.012919-.129191 0-.05684.00517-.09302.00517-.03876.015503-.06201.010335-.02326.025838-.03101.015503-.01033.036174-.01033.036174 0 .1007691.04392.067179.04392.1705323.0956.1033529.05168.248047.09818.1472779.04392.3384808.04392.1446941 0 .26355-.03876.1214397-.03876.2067059-.108521.08785-.07235.1343588-.1757.046509-.103352.046509-.235127 0-.142111-.064596-.24288-.064596-.100769-.1705323-.1757Q5.6593429 13.77952 5.5224003 13.717509 5.3880415 13.652913 5.2459312 13.588318 5.1038209 13.521138 4.9694621 13.44104 4.8351033 13.360941 4.7291666 13.252421 4.6232298 13.1439 4.5560504 12.999206q-.064596-.147278-.064596-.3514 0-.20929.074931-.372071.077515-.165364.2118735-.276469.1369427-.111104.3229779-.167948.1886191-.05943.4056603-.05943.1111044 0 .2222088.02067.1136882.01809.2118735.05168.1007691.03101.1782838.07235.077515.03876.1007691.0646.025838.02325.03359.03876.00775.01292.012919.03617.00517.02067.00775.05168.00258.03101.00258.0801 0 .04651-.00517.08268-.00258.03617-.010335.06201-.00775.02325-.023254.03617-.012919.01033-.031006.01033-.028422 0-.090434-.03617-.059428-.03617-.1472779-.0801-.08785-.04651-.2092897-.08268-.1188558-.03876-.2687176-.03876-.1395264 0-.2428794.03876-.1033529.03617-.1705323.09818-.067179.06201-.1007691.147278-.03359.08527-.03359.180868 0 .139526.064596.240295.064596.100769.1705323.178284.1085206.07752.2454632.14211.1369426.0646.2790529.131775.1421103.0646.2790529.144694.1369427.07752.2428794.186036.1085206.105936.1731162.253214.067179.144694.067179.343649zM8.418866 15.086935q-.010335.02842-.028422.04651-.018087.01809-.051676.02842-.031006.01033-.082682.01292-.049093.0052-.1240235.0052-.056844 0-.1007691-.0026-.041341 0-.072347-.0052-.031006-.0052-.05426-.01033-.020671-.0078-.036174-.01809-.015503-.01033-.025838-.02325-.00775-.0155-.015503-.03617L6.7342133 11.978596q-.020671-.05684-.023254-.09043 0-.03617.023254-.05426.023254-.01809.074931-.02326.051677-.0052.1395265-.0052.072347 0 .1136882.0052.043925.0026.067179.01292.023254.01034.03359.02842.012919.0155.023254.04134l.9585984 2.813783h.00258l.9327602-2.808616q.00775-.02842.018087-.04651.010335-.01809.036174-.02842.025838-.01033.072347-.01292.046509-.0052.1240236-.0052.080099 0 .1266073.0078.046509.0052.062012.02325.018087.01809.012919.05426-.00258.03359-.023254.09043zM12.524561 12.275735q0 .04909-.0052.08785-.0052.03617-.0155.06201-.01033.02326-.02584.03359-.0155.01033-.03359.01033-.03101 0-.103353-.04909-.07235-.04909-.193786-.10852-.12144-.05943-.291972-.108521-.167949-.04909-.400493-.04909-.276469 0-.496094.100769-.219625.100769-.37207.279053-.152446.178284-.235128.423747-.0801.245463-.0801.532267 0 .320394.08785.568441.09043.248047.248047.41858.157613.170532.374654.258382.219625.08785.480592.08785.155029 0 .312642-.03617.160197-.03876.29714-.113689v-.974101h-.775147q-.04392 0-.06718-.04392-.02067-.04392-.02067-.136943 0-.04909.0052-.08268.0052-.03617.0155-.05684.01292-.02326.02842-.03359.0155-.01033.03876-.01033h1.061951q.02842 0 .05684.01033.02842.01033.05168.03101.02325.02067.03617.05684.01292.03617.01292.08268v1.273824q0 .06718-.02325.116272-.02325.04909-.09819.08785-.07493.03617-.193787.0801-.118856.04392-.245463.07493-.126608.03101-.255799.04651-.129191.0155-.255798.0155-.387574 0-.692465-.118856-.304891-.12144-.516764-.343649-.20929-.222209-.3203945-.532267-.1111044-.310059-.1111044-.692465 0-.397909.1188559-.720887.12144-.322978.338481-.550354.219625-.227376.524516-.3514.307475-.126607.679545-.126607.191203 0 .359152.03359.167948.03359.297139.0801.131775.04392.219625.09819.09043.05168.124024.08527.03359.03359.04651.07752.01292.04393.01292.126607z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.3a4b5f97ae684766055159ba5771b452.svg";
export { ForwardRef as ReactComponent };